export default __webpack_public_path__ + "static/media/Employees_TMJ Index.a16cac2b.pdf";